<ng-container *ngIf="test$ | async as currentTest">
  <ng-container *ngIf="question$ | async as currentQuestion">

    <div id="expiredPage" class="pad-t-8 pad-r-t-4">
      <div class="row">
        <!-- título -->
        <div class="col-lg-6 mar-r-b-4 color-primary">
          <p class="title-m title-r-s mar-b-2">
            {{ ('TEST.EXPIREDTEST.TITLE') | translate }}
          </p>
          <!-- subtítulo -->
          <p class="title-s title-r-xs">
            {{ ('TEST.EXPIREDTEST.SUBTITLE') | translate }}
          </p>

          <div class="btn action-button d-none d-lg-inline-block body-m bg-color-tertiary color-white mar-t-4" (click)="returnHome()">
             <ng-container *ngIf="currentTest.invitation.origin === 'myrandstad'">
              {{ 'COMMON.RETURNTOMYRANDSTAD' | translate }}
            </ng-container>
            <ng-container *ngIf="currentTest.invitation.origin !== 'myrandstad'">
              {{ 'COMMON.RETURNTOHOME' | translate }}
            </ng-container>
          </div>
        </div>
        <!-- imagen -->
        <div class="col-lg-6 d-flex justify-content-center">
          <div class="image-container pad-r-x-8">
            <svg viewBox="0 0 450 450" fill="none">
              <path
                  d="M225 349.805C293.928 349.805 349.805 293.928 349.805 225C349.805 156.072 293.928 100.195 225 100.195C156.072 100.195 100.195 156.072 100.195 225C100.195 293.928 156.072 349.805 225 349.805Z"
                   [attr.stroke]="colors.tertiaryColor" stroke-linecap="round" stroke-linejoin="round" />
              <path
                  d="M225 233.789C220.148 233.789 216.211 229.852 216.211 225V100.951C216.211 96.0997 220.148 92.1622 225 92.1622C229.852 92.1622 233.789 96.0997 233.789 100.951V225C233.789 229.852 229.852 233.789 225 233.789Z"
                   [attr.fill]="colors.tertiaryColor" />
              <path
                  d="M283.764 292.553C281.514 292.553 279.264 291.691 277.542 289.986L218.778 231.223C215.35 227.795 215.35 222.223 218.778 218.795C222.206 215.367 227.778 215.367 231.206 218.795L289.969 277.559C293.397 280.986 293.397 286.559 289.969 289.986C288.247 291.709 285.997 292.553 283.747 292.553H283.764Z"
                   [attr.fill]="colors.tertiaryColor" />
              <path
                  d="M225 420.117C117.404 420.117 29.8828 332.596 29.8828 225C29.8828 117.404 117.404 29.8829 225 29.8829C229.852 29.8829 233.789 33.8204 233.789 38.6719C233.789 43.5235 229.852 47.461 225 47.461C127.107 47.461 47.4609 127.107 47.4609 225C47.4609 322.893 127.107 402.539 225 402.539C272.426 402.539 317.004 384.065 350.543 350.543C353.971 347.115 359.543 347.115 362.971 350.543C366.398 353.971 366.398 359.543 362.971 362.971C326.127 399.815 277.119 420.117 225 420.117Z"
                   [attr.fill]="colors.nonaryColor" />
              <path
                  d="M356.748 365.537C354.498 365.537 352.248 364.676 350.525 362.971C347.098 359.543 347.098 353.971 350.525 350.543C384.064 317.004 402.521 272.426 402.521 225C402.521 127.107 322.875 47.461 224.982 47.461C220.131 47.461 216.193 43.5235 216.193 38.6719C216.193 33.8204 220.131 29.8829 224.982 29.8829C332.578 29.8829 420.1 117.404 420.1 225C420.1 277.119 399.797 326.109 362.953 362.971C361.23 364.693 358.98 365.537 356.73 365.537H356.748Z"
                   [attr.fill]="colors.senaryColor" />
              <path
                  d="M225 384.961C136.793 384.961 65.0391 313.207 65.0391 225C65.0391 136.793 136.793 65.0391 225 65.0391C313.207 65.0391 384.961 136.793 384.961 225C384.961 313.207 313.207 384.961 225 384.961ZM225 82.6172C146.496 82.6172 82.6172 146.496 82.6172 225C82.6172 303.504 146.496 367.383 225 367.383C303.504 367.383 367.383 303.504 367.383 225C367.383 146.496 303.504 82.6172 225 82.6172Z"
                   [attr.fill]="colors.tertiaryColor" />
            </svg>
          </div>
        </div>
      <!-- botón mobile -->
        <div class="d-lg-none body-r-m col-12 pad-t-2 mar-t-5">
          <div class="btn action-button bg-color-tertiary color-white" (click)="returnHome()">
              <ng-container *ngIf="currentTest.invitation.origin === 'myrandstad'">
                {{ 'COMMON.RETURNTOMYRANDSTAD' | translate }}
              </ng-container>
              <ng-container *ngIf="currentTest.invitation.origin !== 'myrandstad'">
                {{ 'COMMON.RETURNTOHOME' | translate }}
              </ng-container>
          </div>
        </div>
      </div>
  </div>
  </ng-container>
</ng-container>
